// extracted by mini-css-extract-plugin
export default {"wrapper":"OmXAeI78fb__lOkqmVry","topContents":"ZbkatLQjOhlW2juXo3lx","title":"oJS0nPYbEp0nXFpXrKNJ","iconWrapper":"fEEJAkm8csmExTkYyjKE","bottomContents":"J6g6Kif6cOvu8pIpVhvr"};